import React from "react";
import { Chip } from "@mui/material";

// A color's classification system (the values in COLOR_SYSTEMS) shown as a small chip — the single
// look for a color system everywhere it appears: the colour grids, the relationship grids, and the
// colour autocompletes.
const SystemChip: React.FC<{ system: string }> = ({ system }) => (
  <Chip label={system} size="small" sx={{ mr: 1, fontWeight: 500 }} />
);

export default SystemChip;
